// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".container[data-v-9496d4d8]{font-family:Arial,sans-serif;padding:10px;text-align:center}.text[data-v-9496d4d8]{font-size:22px;margin-bottom:0}.full-height[data-v-9496d4d8]{height:100%}.chart-header[data-v-9496d4d8]{height:auto}.italic[data-v-9496d4d8]{font-style:italic}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
